import React from 'react';
import UseGoogleMapsPreview from "./GoogleMapsPreview.hooks";
import { makeGoogleMapsTemplate } from '../embedUtilities';



const GoogleMapsPreview =({url, setDisableUpload, setIsLoading, isLoading, setEmbedId}:{url: string, setDisableUpload: any, setIsLoading: any, isLoading: boolean, setEmbedId: any}) => {

    const {id, errorString} = UseGoogleMapsPreview(url, isLoading, setIsLoading, setDisableUpload);

    if (errorString) {
        return <span className="error-message">{errorString}</span>
    }
    
    if (isLoading) {
        return <div className="spacer" />
    }

    if (!id) {
        return <span className="error-message">{"We couldn't find a source for that Google Map embed. Please try again."}</span>
    
    } else {
        setEmbedId(id)

        return ( 
            <div className='embed-preview-container googlemaps-preview'>
                <div className="preview-tab">Preview</div>
    
                <div dangerouslySetInnerHTML={{__html:makeGoogleMapsTemplate(id)}}/>
            </div>
        )
    }
}
export default GoogleMapsPreview
